import { Container, Navbar, Image, Button, Modal, Offcanvas } from 'react-bootstrap'; // ✅
import { useState, useEffect } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import logo from './assets/img/logo-sidebar.svg';

const PublicHeader = () => {
    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const [showMenu, setShowMenu] = useState(false); // ✅
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.get('register') === '1') {
            setShowRegisterModal(true); // ✅

            const next = new URLSearchParams(searchParams);
            next.delete('register');
            setSearchParams(next, { replace: true });
        }
    }, [searchParams, setSearchParams]);

    return (
        <>
            <header className="header public flex-grow-1">
                <Container>
                    <Navbar expand="lg">
                        <Navbar.Brand as={Link} to="/">
                            <Image src={logo} alt="aBROADIFY" title="aBROADIFY" />
                        </Navbar.Brand>

                        {/* ✅ Mobile menu */}
                        <Navbar.Toggle
                            aria-controls="public-navbar-nav"
                            onClick={() => setShowMenu(true)} // ✅
                            className="d-lg-none" // ✅
                        />

                        {/* ✅ Desktop buttons only */}
                        <Navbar.Collapse id="public-navbar-nav" className="justify-content-end">
                            <div className="d-none d-lg-flex align-items-center">
                                <Button onClick={() => setShowRegisterModal(true)} className="me-3 btn-sm" variant="primary">
                                    Register
                                </Button>
                                <Button as={Link} to="/" className="btn-sm" variant="primary">
                                    Login
                                </Button>
                            </div>
                        </Navbar.Collapse>

                        {/* ✅ Mobile offcanvas */}
                        <Offcanvas
                            show={showMenu}
                            onHide={() => setShowMenu(false)}
                            placement="start"
                            className="d-lg-none"
                        >
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>
                                    <Link to="/" className="logo" onClick={() => setShowMenu(false)}>
                                        <Image src={logo} alt="aBROADIFY" title="aBROADIFY" />
                                    </Link>
                                </Offcanvas.Title>
                            </Offcanvas.Header>

                            <Offcanvas.Body className="sidebar d-flex flex-column">
                                <div className="nav flex-column">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowRegisterModal(true);
                                            setShowMenu(false);
                                        }}
                                        className="p-3 bg-transparent border-0 text-start w-100"
                                    >
                                        Register
                                    </button>

                                    <Link
                                        to="/"
                                        onClick={() => setShowMenu(false)}
                                        className="-p-3"
                                    >
                                        Login
                                    </Link>
                                </div>

                                <div className="mt-auto px-3">
                                    <Button
                                        variant="outline-secondary"
                                        className="w-100 justify-content-center mb-3"
                                        onClick={() => window.location.assign('https://abroadify.me/')}
                                    >
                                        Back to website
                                    </Button>
                                </div>
                            </Offcanvas.Body>
                        </Offcanvas>

                    </Navbar>
                </Container>
            </header>

            {/* Register Modal */}
            <Modal show={showRegisterModal} onHide={() => setShowRegisterModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>We'll be live soon!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Meanwhile you can donate to make our platform better.</p>
                </Modal.Body>
                <Modal.Footer className="flex-column flex-md-row">
                    <Button
                        variant="primary"
                        className="me-md-3 mb-3 mb-md-0"
                        onClick={() => {
                            setShowRegisterModal(false);
                            navigate('/donations-my?donate=1');
                        }}
                    >
                        Donate
                    </Button>

                    <Button
                        variant="outline-secondary"
                        onClick={() => window.location.assign('https://abroadify.me/')}
                    >
                        Back to website
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PublicHeader;
